import React from 'react';

const PersonalInfo = ({ formData, updateFormData }) => {
  return (
    <div className="form-section-content">
      <h3 className="section-title">Informations personnelles</h3>
      <div className="form-group">
        <label className="form-label" htmlFor="nom">
          Nom complet
        </label>
        <input
          type="text"
          id="nom"
          className="form-input"
          placeholder="Jean Dupont"
          value={formData.nom}
          onChange={(e) => updateFormData('nom', e.target.value)}
        />
      </div>
      
      <div className="form-group">
        <label className="form-label" htmlFor="poste">
          Poste / Fonction
        </label>
        <input
          type="text"
          id="poste"
          className="form-input"
          placeholder="Directeur Marketing"
          value={formData.poste}
          onChange={(e) => updateFormData('poste', e.target.value)}
        />
      </div>
      
      <div className="form-group">
        <label className="form-label" htmlFor="departement">
          Département / Pôle
        </label>
        <input
          type="text"
          id="departement"
          className="form-input"
          placeholder="Marketing & Communication"
          value={formData.departement}
          onChange={(e) => updateFormData('departement', e.target.value)}
        />
      </div>
      
      <div className="form-group">
        <label className="form-label" htmlFor="entreprise">
          Entreprise
        </label>
        <input
          type="text"
          id="entreprise"
          className="form-input"
          placeholder="Mon Entreprise SARL"
          value={formData.entreprise}
          onChange={(e) => updateFormData('entreprise', e.target.value)}
        />
      </div>
    </div>
  );
};

export default PersonalInfo;